import { Image } from "react-bootstrap";
import AustinLogo from "../assets/img/austinlogo.svg";

export const BlockInput = ({ blocking = false }) =>
	blocking ? (
		<div className="block-ui-container" data-testid="test-blockInput">
			<div className="block-ui-overlay" />
			<div className="loader-element animate__animated animate__jackInTheBox">
				<Image
					id="indicator"
					className="shimmer opacity-75 "
					src={AustinLogo}
					height={40}
				/>
			</div>
			<span className="hide">Loading</span>
		</div>
	) : null;
